import moment from 'moment-timezone';
import qs from 'qs';
import {
  PROJECT_OPTIONS_REQUEST,
  PROJECT_OPTIONS_FAILURE,
  PROJECT_OPTIONS_SUCCESS,
} from '../constants/actions';
import config from '../../config';
import { getItem, setItem } from '../utils/storage';
import { fetchM } from './fetchM';
import { handleError } from './error';

function projectOptionsRequest() {
  return {
    type: PROJECT_OPTIONS_REQUEST,
  };
}

function projectOptionsSuccess(data, token = null) {
  return {
    type: PROJECT_OPTIONS_SUCCESS,
    payload: {
      data,
      token,
    },
  };
}

function projectOptionsError(message) {
  return {
    type: PROJECT_OPTIONS_FAILURE,
    payload: {
      statusText: message,
    },
  };
}

export function fetchProjectOptions(fresh = true) {
  return (dispatch) => {
    let token = null;
    let reload = false;
    dispatch(projectOptionsRequest());
    if (!fresh) {
      let projectOptionsData = {};
      try {
        projectOptionsData = JSON.parse(getItem(`${config.get('appName')}.projectOptions`)) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (
        !projectOptionsData.data ||
        config.get('version') !== projectOptionsData.version ||
        moment().isAfter(moment(projectOptionsData.createdAt).add(1, 'day'))
      ) {
        reload = true;
      }
      if (!reload) {
        dispatch(projectOptionsSuccess(projectOptionsData.data));
        return Promise.resolve();
      }
    }
    const q = Object.assign({
      limit: 0,
    });
    return dispatch(fetchM(`/specifications/options/?${qs.stringify(q)}`, {
      credentials: 'include',
    }))
      .then((res) => {
        token = res.headers.get('X-Csrf-Token');
        return res.json();
      })
      .then((data) => {
        try {
          setItem(`${config.get('appName')}.projectOptions`, JSON.stringify({
            data,
            createdAt: moment().toDate(),
            version: config.get('version'),
          }));
        } catch (e) {
          Bugsnag.notifyException(e);
        }
        dispatch(projectOptionsSuccess(data, token));
      })
      .catch(err => dispatch(handleError(err, projectOptionsError)));
  };
}



// WEBPACK FOOTER //
// ./src/actions/projectOptions.js